export function Separator() {
  return <div className="h-[1px] bg-neutrals-N300 w-full" />;
}
